import styled, { css } from 'styled-components';

import { hexWithAlpha } from '@p2l/utils';

export const defaultButton = `
  display: inline-flex;
  align-items: center;
  border: none;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;

  svg {
    &:first-child {
      margin: 0 8px 0 0;
    }

    &:last-child {
      margin: 0 0 0 8px;

      &:first-child {
        margin: 0;
      }
    }
  }

  @media (max-width: 960px) {
    cursor: default;
  }
`;

export const BlankTextButton = styled.button`
  ${defaultButton}
  padding: 8px 16px;
  background: transparent;
  text-transform: uppercase;
  color: ${({ disabled }) => hexWithAlpha('#0E1418', disabled ? 40 : 100)};
  transition: all 0.1s ease;

  &:hover {
    background: ${({ theme, color }) => (color ? hexWithAlpha(color, 8) : hexWithAlpha('#0E1418', 8))};
  }
`;
